<template>
	<div :class="['panel',panelType]">
		<div :class="['panel-heading',{'accordion-toggle':inAccordion}]"
			 @click.prevent="inAccordion&&toggle()">

			{{ header }}

			<svg class="icon-faq">
				<use :xlink:href="`#${iconId}`"></use>
			</svg>
		</div>

		<transition
			name="collapse"
			@enter="enter"
			@after-enter="afterEnter"
			@before-leave="beforeLeave">

			<div class="panel-collapse" v-if="open">
				<div class="panel-body">
					<slot></slot>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
/* eslint-disable */

export default {
	name: 'panel',
	introduction: 'Vuejs panel component',
	description: 'Require to use Accordion component.',
	props: {
		header: {
			type: String,
			default: null,
			note: 'Header text on panel'
		},
		isOpen: {
			type: Boolean,
			default: null,
			note: 'Show or close panel'
		},
		type: {
			type: String,
			default: null,
			note: 'Panel type'
		},
		openIconId: {
			type: String,
			default: 'icon-page-down',
			note: 'Panel open icon\'s svg id',
		},
		closeIconId: {
			type: String,
			default: 'icon-page-right',
			note: 'Panel close icon\'s svg id',
		}
	},
	data() {
		return {
			open: this.isOpen,
		};
	},
	watch: {
		isOpen(val) {
			this.open = val;
		}
	},
	computed: {
		inAccordion() {
			return this.$parent && this.$parent.accordion;
		},
		panelType() {
			const panelType = `panel-${this.type || (this.$parent && this.$parent.type) || 'default'}`;
			return panelType;
		},
		iconId() {
			return this.open ? this.openIconId : this.closeIconId;
		},
	},
	methods: {
		toggle() {
			this.open = !this.open;
			if (this.inAccordion) {
				this.$parent.open(this);
			}
		},
		enter(el) {
			const endWidth = getComputedStyle(el).height;
			el.style.height = 'auto';
			el.style.height = '0px';
			el.offsetHeight;
			el.style.height = endWidth;
		},
		afterEnter(el) {
			el.style.height = 'auto';
		},
		beforeLeave(el) {
			el.style.height = getComputedStyle(el).height;
			el.offsetHeight;
			el.style.height = '0px';
		},
	},
	created() {
		if (this.isOpen === null) {
			this.open = !this.inAccordion;
		}
	}
};
</script>

<style lang="less" scoped>
	.accordion-toggle {
		cursor: pointer;
		.icon-faq {
			position: relative;
			float: right;
			width: 12px;
			height: 12px;
			transition: .3s ease;
			opacity: .5;
		}
		&:hover {
			color: #262626;
			.icon-faq {
				opacity: 1;
			}
		}
	}
	.collapse-enter-active,
	.collapse-leave-active {
		transition: all .5s ease;
		overflow: hidden;
	}
</style>
